export default "__VITE_ASSET__76bbb504__"